import { enAdmin } from '../en';
import { frAdmin } from '../fr';
import { esAdmin } from '../es';
import { deAdmin } from '../de';

// Alias for the former `admin` module. This lets us migrate code from
// t('admin.*') to t('backoffice.*') incrementally without duplicating strings.
export const backofficeModuleTranslations = {
  en: enAdmin,
  fr: frAdmin,
  es: esAdmin,
  de: deAdmin,
} as const;

